// extracted by mini-css-extract-plugin
export default {"title":"titleConfigs_title__9PDQm"};